'use client';

import { ArrowBack } from '@mui/icons-material';
import { getIsMobile } from '@/libs/utils/user';
import MobilePlan from './m';
import PcPlan from './pc';
import * as S from './styles';

interface EnterprisePlanProps {
  onOpenContact?: (isMobile: boolean) => void;
}

const EnterprisePlan = ({ onOpenContact }: EnterprisePlanProps) => {
  const isMobile = getIsMobile();
  const description = isMobile ? '리뷰 운영 부담은 줄이고,\n매출은 높이는 엔터프라이즈 혜택' : '리뷰 운영 부담은 줄이고, 매출은 높이는 엔터프라이즈 혜택';

  return (
    <S.Container>
      <S.Inner>
        <S.Title>
          복잡한 병원 리뷰 운영 업무는
          <br />
          <S.HighlightText>리뷰웍스팀</S.HighlightText>에게 맡기세요!
        </S.Title>
        <S.Description>{description}</S.Description>
        <S.BtnContact onClick={() => onOpenContact?.(isMobile)}>
          바로 상담 신청하기
          <ArrowBack sx={{ marginLeft: '8px', transform: 'rotate(180deg)' }} />
        </S.BtnContact>
        {isMobile ? <MobilePlan /> : <PcPlan />}
      </S.Inner>
    </S.Container>
  );
};

export default EnterprisePlan;
